import React from "react";
import { motion } from "framer-motion";
import "./FamiliarQuestionnaire.css"; // Import du fichier CSS

const FamiliarQuestionnaire = () => {
    return (
        <div className="familiar-container">
            <motion.h2
                className="familiar-title"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                Cela vous semble-t-il familier?
            </motion.h2>

            <motion.ul
                className="familiar-list"
                initial="hidden"
                animate="visible"
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
                }}
            >
                {[
                    "Vous avez des objets de valeur qui étaient autrefois spéciaux, mais qui ne font maintenant qu'accumuler de la poussière.",
                    "Vous avez des héritages avec une histoire, mais qui n'ont que peu de signification pour vous.",
                    "Vos goûts et votre vie ont changé ; autrefois, vous les trouviez magnifiques, mais aujourd'hui ils ne vous correspondent plus.",
                    "Un petit coussin financier supplémentaire vous serait utile pour quelque chose qui compte vraiment maintenant.",
                    "Votre maison se remplit de plus en plus ; de vieux objets occupent de l'espace là où vous aimeriez avoir quelque chose de nouveau.",
                    "Vous possédez de belles choses que vous n'utilisez jamais, mais qui pourraient certainement rendre quelqu'un d'autre heureux."
                ].map((text, index) => (
                    <motion.li
                        key={index}
                        className="familiar-item"
                        variants={{ hidden: { opacity: 0, x: -20 }, visible: { opacity: 1, x: 0 } }}
                    >
                        <span>✔️</span> {text}
                    </motion.li>
                ))}
            </motion.ul>
        </div>
    );
};

export default FamiliarQuestionnaire;
